import defer from 'lib/defer'
import { safeSetLocalStorageItem, cleanupOldImageData, getLocalStorageSizeMB } from 'lib/localStorageUtils'

const LOCAL_EVENTS = new window.EventTarget()

const storageBus = {

  subscribe(onChange){
    LOCAL_EVENTS.addEventListener('storage', onChange)
    window.addEventListener('storage', onChange)
    return () => {
      LOCAL_EVENTS.removeEventListener('storage', onChange)
      window.removeEventListener('storage', onChange)
    }
  },

  getItem(storage, key){
    return storage[key]
  },

  setItem(storage, key, newValue){
    const oldValue = storage[key]
    if (newValue === oldValue) return

    if (newValue === undefined || newValue === null) {
      delete storage[key]
      deferChange(storage, key, oldValue)
      return
    }

    if (storage === window.localStorage) {
      const success = this.safeSetLocalStorageItem(key, newValue)
      if (!success) {
        this.cleanupStorageSpace()
        this.safeSetLocalStorageItem(key, newValue)
      }
    } else {
      storage[key] = newValue
    }
    deferChange(storage, key, oldValue)
  },

  safeSetLocalStorageItem(key, value) {
    return safeSetLocalStorageItem(key, value, (error) => {
      console.warn('localStorage quota exceeded, attempting cleanup...', {
        key: key.substring(0, 50) + (key.length > 50 ? '...' : ''),
        valueSizeKB: ((key.length + value.length) / 1024).toFixed(1),
        currentSizeMB: getLocalStorageSizeMB().toFixed(1),
        error: error.message
      })
    })
  },

  cleanupStorageSpace() {
    try {
      const patternsToCleanup = [
        'MarketplaceProductForm.*',
        'CropImageInput.*',
        '.*images.*',
        '.*productImages.*'
      ]

      const removedCount = cleanupOldImageData(patternsToCleanup, 5 * 24 * 60 * 60 * 1000)

      if (removedCount > 0) {
        console.log(`Cleaned up ${removedCount} old image items from localStorage`)
      }

      if (getLocalStorageSizeMB() > 4) {
        const moreRemovedCount = cleanupOldImageData(patternsToCleanup, 24 * 60 * 60 * 1000)
        if (moreRemovedCount > 0) {
          console.log(`Aggressively cleaned up ${moreRemovedCount} more items from localStorage`)
        }
      }
    } catch (error) {
      console.error('Error during localStorage cleanup:', error)
    }
  }
}

export default storageBus

const deferredChangesByStorage = new Map()
function deferChange(storage, key, oldValue){
  let deferredChanges = deferredChangesByStorage.get(storage)
  if (!deferredChanges) deferredChangesByStorage.set(storage, deferredChanges = {})
  if (!(key in deferredChanges)) deferredChanges[key] = oldValue
  if (!handleDeferredChangesTimeout)
    handleDeferredChangesTimeout = defer(handleDeferredChanges)
}

let handleDeferredChangesTimeout
function handleDeferredChanges(){
  handleDeferredChangesTimeout = undefined
  for (const storage of [window.sessionStorage, window.localStorage]){
    const deferredChanges = deferredChangesByStorage.get(storage)
    deferredChangesByStorage.delete(storage)
    if (deferredChanges)
      for (const key in deferredChanges)
        dispatchChangeEvent(storage, key, deferredChanges[key])
  }
}

function dispatchChangeEvent(storage, key, oldValue){
  const newValue = storage[key]
  if (newValue === oldValue) return
  const changeEvent = new window.Event('storage')
  Object.assign(changeEvent, {
    storageArea: storage,
    key,
    oldValue,
    newValue,
  })
  LOCAL_EVENTS.dispatchEvent(changeEvent)
}
